import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Footer from '@/components/feature/Footer';
import FloatingWhatsApp from '@/components/feature/FloatingWhatsApp';
import { CONTACT } from '@/mocks/contactInfo';
import { useDocumentHead } from '@/hooks/useDocumentHead';

export default function Merci() {
  useDocumentHead({
    title: 'Demande bien reçue — Gwada Nuisibles',
    description: 'Votre demande de devis a bien été reçue. Un technicien Gwada Nuisibles vous répond sous 2 h ouvrées avec un prix ferme.',
    noindex: true,
  });

  return (
    <main>
      <Header />
      <Breadcrumb items={[{label:'Accueil',href:'/'},{label:'Merci'}]} />

      <section className="bg-primary-500 py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-white/20">
            <i className="ri-check-line text-white text-4xl w-10 h-10 flex items-center justify-center"></i>
          </div>
          <h1 className="font-heading font-black text-3xl md:text-4xl text-white mb-6">
            Bien reçu&nbsp;!
          </h1>
          <p className="text-white/85 text-base md:text-lg leading-relaxed mb-8 max-w-xl mx-auto">
            Votre demande est entre les mains d&rsquo;un technicien. Vous recevrez votre prix ferme sous 2 h ouvrées (par téléphone ou WhatsApp).
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={CONTACT.phoneHref}
              className="inline-flex items-center gap-2 bg-white text-primary-600 px-6 py-3 rounded-lg font-semibold text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
              {CONTACT.phone}
            </a>
            <a
              href={CONTACT.whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-whatsapp-500 text-white px-6 py-3 rounded-lg font-semibold text-sm hover:bg-whatsapp-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
              WhatsApp {CONTACT.whatsapp}
            </a>
          </div>
        </div>
      </section>

      {/* CONSEILS EN ATTENDANT */}
      <section className="bg-white py-14 md:py-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <p className="text-foreground-500 text-sm uppercase tracking-wider text-center mb-8">
            En attendant, trois réflexes utiles selon votre cas
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="w-10 h-10 mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-bowl-line text-secondary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-950 text-base mb-2">Rats</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Rangez les aliments en boîtes rigides, ne bouchez pas encore les trous.
              </p>
            </div>
            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="w-10 h-10 mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-forbid-line text-secondary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-950 text-base mb-2">Ravets</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Ne pulvérisez pas de bombe insecticide — ça disperse la colonie avant notre passage.
              </p>
            </div>
            <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
              <div className="w-10 h-10 mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-t-shirt-line text-secondary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-950 text-base mb-2">Punaises</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Isolez le linge de la chambre dans des sacs fermés, lavez à 60 °C.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
            <Link to="/" className="inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
              Retour à l&rsquo;accueil
            </Link>
            <Link to="/blogue" className="inline-flex items-center gap-2 bg-background-100 text-foreground-800 px-6 py-3 rounded-lg font-semibold text-sm border border-background-300/60 hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-article-line w-4 h-4 flex items-center justify-center"></i>
              Nos conseils sur le blogue
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}